import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-lms-footer',
  templateUrl: './lms-footer.component.html',
  styleUrls: ['./lms-footer.component.scss'],
})
export class LmsFooterComponent implements OnInit {

  @Input() copyrightMsg: any;
  constructor() { }

  ngOnInit(): void {}
}
